import { ScheduleApiResponse } from "../resources/Schedule.apiResponse";

export class ScheduleViewModel {
  id: string;
  open: string;
  close: string;
  dayOfWeek: number;
  interval: number;
  isHoliday: boolean;

  constructor(apiResponse: ScheduleApiResponse) {
    this.id = apiResponse.id;
    this.open =
      apiResponse.open === ""
        ? ""
        : apiResponse.open.split(":").slice(0, 2).join(":");
    this.close =
      apiResponse.close === ""
        ? ""
        : apiResponse.close.split(":").slice(0, 2).join(":");
    this.dayOfWeek = apiResponse.dayOfWeek;
    this.interval = apiResponse.interval;
    this.isHoliday = apiResponse.isHoliday;
  }
}
